var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _ellipse, _ellipse2, _ellipse3, _ellipse4, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9949 10.5271C30.9958 11.4516 31.2419 12.3596 31.7083 13.1599C32.6587 14.7872 32.6619 16.7942 31.7166 18.4244C31.2501 19.2247 31.004 20.1327 31.0031 21.0572C31.0029 22.9381 29.9916 24.6761 28.3501 25.6164C27.5439 26.0788 26.8743 26.7433 26.4084 27.5434C25.4608 29.1724 23.7096 30.176 21.8143 30.1762C20.8826 30.1769 19.9676 30.4211 19.1613 30.8843C17.52 31.8249 15.4977 31.8249 13.8565 30.8843C13.0501 30.4211 12.1351 30.1769 11.2035 30.1762C9.30817 30.176 7.55692 29.1724 6.60936 27.5434C6.14343 26.7433 5.47383 26.0788 4.66765 25.6164C3.0262 24.6761 2.0149 22.9381 2.01468 21.0572C2.01373 20.1327 1.76767 19.2247 1.30122 18.4244C0.35337 16.7956 0.35337 14.7887 1.30122 13.1599C1.76576 12.3591 2.00991 11.4511 2.00919 10.5271C2.01118 8.64789 3.02223 6.91223 4.66216 5.97274C5.46835 5.51036 6.13794 4.84585 6.60387 4.04579C7.55165 2.4171 9.30282 1.41375 11.198 1.41352C12.1296 1.41284 13.0447 1.16863 13.851 0.705483C15.4922 -0.235161 17.5146 -0.235161 19.1558 0.705483C19.9627 1.16673 20.8777 1.40905 21.8088 1.40807C23.7031 1.40938 25.453 2.41283 26.4002 4.04089C26.8661 4.84095 27.5357 5.50545 28.3419 5.96784C29.9833 6.9082 30.9946 8.64614 30.9949 10.5271ZM9.36816 15.7913C9.36816 19.7017 12.5624 22.8717 16.5028 22.8717C18.395 22.8717 20.2097 22.1257 21.5477 20.7979C22.8857 19.4701 23.6374 17.6692 23.6374 15.7913C23.6374 11.8809 20.4431 8.71094 16.5028 8.71094C12.5624 8.71094 9.36816 11.8809 9.36816 15.7913Z",
    fill: "#52AC39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7082 13.1597C31.2417 12.3594 30.9957 11.4514 30.9947 10.5269C30.9945 8.64596 29.9832 6.90802 28.3418 5.96766C27.8001 5.65356 27.3188 5.24657 26.9203 4.76563C26.3605 8.051 25.168 11.1985 23.4079 14.036C24.0663 16.5592 23.2713 19.2371 21.3397 21.003C19.408 22.7689 16.6536 23.3359 14.1736 22.478C11.2611 24.0105 8.14368 25.1237 4.91504 25.784C5.60861 26.2313 6.18695 26.8336 6.60374 27.5427C7.55131 29.1717 9.30255 30.1753 11.1979 30.1755C12.1295 30.1762 13.0445 30.4204 13.8508 30.8835C15.4921 31.8242 17.5144 31.8242 19.1557 30.8835C19.962 30.4204 20.877 30.1762 21.8087 30.1755C23.704 30.1753 25.4552 29.1717 26.4028 27.5427C26.8687 26.7426 27.5383 26.0781 28.3445 25.6157C29.986 24.6754 30.9973 22.9374 30.9975 21.0565C30.9984 20.132 31.2445 19.224 31.7109 18.4237C32.6577 16.7945 32.6567 14.7879 31.7082 13.1597Z",
    fill: "#45922F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6616 9.25586L10.4663 15.7916L12.6616 15.247L14.308 17.4255L16.5033 9.25586H12.6616Z",
    fill: "#FF4C5D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3446 9.25586L22.5399 15.7916L20.3446 15.247L18.6982 17.4255L16.5029 9.25586H20.3446Z",
    fill: "#FF4C5D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5608 2.43842L9.79798 4.70904C9.6932 5.02114 9.73616 5.36352 9.91486 5.6406C10.0936 5.91767 10.3889 6.09975 10.7183 6.13601L14.3081 6.53197L15.9546 4.35339L12.2111 1.87634C11.9264 1.68798 11.5695 1.64213 11.2459 1.75235C10.9223 1.86258 10.669 2.11627 10.5608 2.43842Z",
    fill: "#FF4C5D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3078 6.53516L10.6017 7.35212C10.2915 7.42054 10.0264 7.61903 9.8749 7.89627C9.72343 8.1735 9.70047 8.50229 9.81195 8.79761L10.5293 10.6957C10.6469 11.0074 10.9016 11.2486 11.2208 11.3506C11.54 11.4526 11.8887 11.4041 12.1675 11.2191L15.9543 8.71374L14.3078 6.53516Z",
    fill: "#FF4C5D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4455 2.43842L23.2084 4.70904C23.3131 5.02114 23.2702 5.36352 23.0915 5.6406C22.9128 5.91767 22.6175 6.09975 22.288 6.13601L18.6982 6.53197L17.0518 4.35339L20.7952 1.87634C21.0799 1.68798 21.4368 1.64213 21.7604 1.75235C22.0841 1.86258 22.3374 2.11627 22.4455 2.43842Z",
    fill: "#FF4C5D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6982 6.53516L22.4044 7.35212C22.7146 7.42054 22.9797 7.61903 23.1311 7.89626C23.2826 8.1735 23.3056 8.50228 23.1941 8.79761L22.4768 10.6962C22.3591 11.0078 22.1043 11.2489 21.7851 11.3508C21.4659 11.4527 21.1173 11.4042 20.8386 11.2191L17.0518 8.71374L18.6982 6.53516Z",
    fill: "#FF4C5D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5771 17.9707H27.4795C27.4795 19.7755 28.9538 21.2386 30.7724 21.2386H31.87C31.87 19.4338 30.3957 17.9707 28.5771 17.9707Z",
    fill: "#76E756"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3081 25.0511V26.1404C16.1267 26.1404 17.601 24.6773 17.601 22.8725V21.7832C15.7824 21.7832 14.3081 23.2463 14.3081 25.0511H14.3081Z",
    fill: "#76E756"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.78269 6.53516H1.68506C1.68506 8.33995 3.15934 9.80303 4.97795 9.80303H6.07558C6.07558 7.99823 4.6013 6.53516 2.78269 6.53516Z",
    fill: "#76E756"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.42916,
    cy: 16.3371,
    rx: 1.64645,
    ry: 1.63393,
    fill: "#FF4C5D"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.4795,
    cy: 10.8898,
    rx: 1.64645,
    ry: 1.63393,
    fill: "#FF4C5D"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.54,
    cy: 25.0499,
    rx: 1.64645,
    ry: 1.63393,
    fill: "#FF4C5D"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.36812,
    cy: 23.9601,
    rx: 1.64645,
    ry: 1.63393,
    fill: "#FF4C5D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.3081,
    y: 3.26562,
    width: 4.39052,
    height: 6.53574,
    rx: 1.09076,
    fill: "#B7313E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecor);
export default __webpack_public_path__ + "static/media/decor.5a47a89a0178fa4d47914c008896c248.svg";
export { ForwardRef as ReactComponent };